import React from 'react'
import { Services } from '@/services/services'
import { CurrentSession } from '@/services/repository/session'
import { LoggedInPageLayout } from '@/components/layout/LoggedInLayout'
import MapComponent from '@/components/Map/Map'

import './Map.css'
import { BackButton } from '@/components/layout/NavBar'

export const MapPage = ({ services, session }: { services: Services, session: CurrentSession }) => {
  // const { translates } = session

  return <LoggedInPageLayout pageName='dashboard-map' services={services} session={session}
    navbarLeft={<BackButton services={services} translates={session.translates} />}>
    <MapComponent fetchUrl='/api/communal/map' />
  </LoggedInPageLayout>
}
